import { logger as LOG } from '@sweetgreen/garnish';

export const telemetryLogger = LOG.extend('Telemetry');
export const telemetryEventLogger = LOG.extend('TelemetryEvent');

LOG.disable('Telemetry');
LOG.disable('TelemetryEvent');
